import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  AccountBalanceWallet,
  DateRange,
  HourglassEmpty,
} from '@material-ui/icons';

import { getFullName, getDateRange } from '../../utils';
import { BOOKING_STAGES } from '../../constants';
import RenderProfilePic from '../../extras/RenderProfilePic';

export class ApprovalBookingCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      booking: {},
    };
  }

  componentDidMount = () => {
    this.setState({
      booking: { ...this.props.bookingData },
    });
  };

  componentDidUpdate = (prevProps, prevStates) => {
    if (prevProps !== this.props) {
      this.setState({
        booking: { ...this.props.bookingData },
      });
    }
  };

  render() {
    return (
      <div>
        <div className='bg-white p-4 border border-gray-300 rounded-lg '>
          {/* header */}
          <div className='flex justify-between ml-1.5'>
            <div>
              <h1 className='text-xl font-semibold opacity-80'>
                {this.state.booking?.themeName}
              </h1>
              <h2 className='text-lg font-medium opacity-60 mt-0.5'>
                {this.state.booking?.subTopicName}
              </h2>
            </div>
            <div>
              <span className='text-xs opacity-30 mr-8'>
                Booking ID: {this.state.booking?.id}
              </span>
              {this.state.booking?.stage ===
              BOOKING_STAGES.ADMIN_ON_HOLD.value ? (
                <span className='bg-red-500 text-sm text-white px-4 py-1 rounded'>
                  HOLD
                </span>
              ) : (
                <span className='bg-yellow-500 text-sm text-white px-4 py-1 rounded'>
                  NEW
                </span>
              )}
            </div>
          </div>

          {/* candidate info */}
          <div className='flex items-center gap-2 my-4 ml-2'>
            <span className='opacity-30'>Candidate: </span>
            <RenderProfilePic
              thumbnail={this.state.booking?.Student?.thumbnail}
              name={this.state.booking?.Student?.firstName}
              size={3}
            />
            <span className='opacity-60'>
              {`${getFullName(this.state.booking?.Student)}`}
            </span>
            <span className='opacity-30 text-2xl font-thin'>|</span>
            <span className='opacity-60'>
              {this.state.booking?.Student?.phone}
            </span>
            <span className='opacity-30 text-2xl font-thin'>|</span>
            <span className='opacity-60'>
              {this.state.booking?.Student?.email}
            </span>
            {/* <span className='text-gray-300 mx-3'>|</span> */}
            {/* <a
              href={this.state.booking?.Student?.resume}
              className='text-blue-500 font-bold'
            >
              Download Resume
            </a> */}
          </div>

          {!this.state.booking?.coachId ? (
            // assign coach button
            <div className='my-5 flex items-center pb-2'>
              <span className='text-gray-400 mr-3'>Coach: </span>
              <input
                placeholder='Assign Mentor'
                value={this.state.coachAssigned}
                type='text'
                list='mentorList'
                onChange={(e) =>
                  this.setState({
                    coachAssigned: e.target.value,
                    assignCoachBtn: true,
                  })
                }
                className='py-2 rounded px-5 border border-gray-300 text-sm'
              />
              <datalist id='mentorList'>
                {/* <option className="text-gray-400" value=''>Assign Mentor</option> */}
                {this.state?.allUsers?.map((user, index) => (
                  <option className='py-2 text-sm' value={user?.id} key={index}>
                    {getFullName(user) + '--' + user?.email}
                  </option>
                ))}
              </datalist>
              {this.state?.assignCoachBtnText === '' ? (
                <button
                  onClick={this.assignCoachHandler}
                  className='mx-3 py-1 px-3 rounded bg-green-400 text-white text-sm'
                  hidden={!this.state.assignCoachBtn}
                >
                  Assign Coach
                </button>
              ) : (
                <span className='text-blue-500 font-semibold'>
                  Assigning Coach...
                </span>
              )}
            </div>
          ) : (
            // coach info
            <div className='flex items-center gap-2 my-4 ml-2'>
              <span className='opacity-30 mr-8'>Coach: </span>
              <RenderProfilePic
                thumbnail={this.state.booking?.Coach?.thumbnail}
                name={this.state.booking?.Coach?.firstName}
                size={3}
              />
              <span className='opacity-60'>
                {`${getFullName(this.state.booking?.Coach)}`}
              </span>
              <span className='opacity-30 text-2xl font-thin'>|</span>
              <span className='opacity-60'>
                {this.state.booking?.Coach?.phone}
              </span>
              <span className='opacity-30 text-2xl font-thin'>|</span>
              <span className='opacity-60'>
                {this.state.booking?.Coach?.email}
              </span>
            </div>
          )}

          {/*  */}
          <hr className='border-t border-gray-300 -mx-4' />
          <div className='flex justify-between items-center mt-4'>
            <div className='flex items-center gap-16 opacity-50'>
              <div className='flex items-center gap-2'>
                <DateRange />
                <span>{getDateRange(this.state?.booking)}</span>
              </div>
              <div className='flex items-center gap-2'>
                <HourglassEmpty />
                <span>{this.state.booking?.duration || 'N/A'} Mins</span>
              </div>
              <div className='flex items-center gap-2'>
                <AccountBalanceWallet />
                <span>Total Earning: {this.state.booking?.totalEarning}</span>
              </div>
            </div>
            <Link
              to={'review-session/' + this.state.booking?.id}
              className='rounded bg-green-c1 text-white px-6 py-2'
            >
              Review Session
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default ApprovalBookingCard;
